import React, { useState } from 'react';
import { Palette, ExternalLink, Search } from 'lucide-react';

const INTERIOR_SITES = [
    { name: '오스템 인테리어', url: 'https://interior.denall.com/', desc: '치과 인테리어 시장 점유율 1위, 1,000호 이상 시공' },
    { name: '덴티움 인테리어', url: 'https://www.dentium.co.kr/', desc: 'All In One 치과 인테리어 설계/시공' },
    { name: '우리집인테리어디자인', url: 'https://medinterior.com/', desc: '병원/메디컬 공간 인테리어 전문 10년 경력' },
    { name: '메디게이트 인테리어', url: 'https://www.medigate.net/allinone/sub/post/BIZ005', desc: '13만 의사 플랫폼 인테리어 업체 매칭' },
    { name: '호스테리어', url: 'https://www.hosterior.com/', desc: '현직 의료인 운영, 완공 보장 감리시스템' },
    { name: '병원인테리어다모아', url: 'https://h-damoa.com/', desc: '병원 인테리어 업체 매칭/무료 견적' },
    { name: '메디프렌드', url: 'https://www.medifriend.co.kr/', desc: '1996년 설립, 병원 인테리어/개원 종합 서비스' },
    { name: '굿테리어', url: 'https://goodterior.com/', desc: '3D 미리보기, 치과 인테리어 200건 이상' },
    { name: '참신디자인', url: 'https://charmshin.com/', desc: '병의원 전문 인테리어 설계/시공' },
    { name: '큐플레이스', url: 'https://www.qplace.kr/', desc: '병원 인테리어 가이드 및 업체 정보' },
];

const CONSULTING_SITES = [
    { name: '개원닷컴', url: 'https://www.gaewon.net/', desc: '국내 최대 개원정보 플랫폼, 547건 이상 실적', cat: '개원컨설팅' },
    { name: '세마 병원컨설팅', url: 'https://semaconsulting.co.kr/', desc: '대한민국 No.1 병원경영컨설팅 그룹', cat: '개원컨설팅' },
    { name: '잘되는자리', url: 'https://successpot.co.kr/', desc: '빅데이터 기반 입지 분석, 현직 개원의 운영', cat: '개원컨설팅' },
    { name: '브레인스펙', url: 'https://www.brainspec.co.kr/', desc: '치과 경영 컨설팅 및 교육 전문', cat: '경영컨설팅' },
    { name: '스타리치 어드바이져', url: 'https://www.starrich.co.kr/hospital/support11', desc: '병/의원 개원 Total Consulting', cat: '개원컨설팅' },
    { name: '위즈벤', url: 'https://wizben.com/', desc: '치과 전문 데이터 경영 컨설팅, 몽매니저 SW', cat: '경영컨설팅' },
    { name: '메디굿', url: 'https://www.medigood.net/', desc: '개원 기획~운영 종합 의료컨설팅', cat: '개원컨설팅' },
    { name: '닥터CEO', url: 'https://www.doctorceo.biz/', desc: '병의원 전문 세무 기장, 절세/MSO 컨설팅', cat: '세무/재무' },
    { name: '택스스퀘어', url: 'https://taxsquare.co.kr/', desc: '병의원 전문 세무관리, 재무진단', cat: '세무/재무' },
    { name: '닥터마케팅', url: 'https://doctormarketing.co.kr/', desc: '병원 블로그/SNS/홈페이지 통합 마케팅', cat: '마케팅' },
    { name: '라온하제코리아', url: 'https://raonhajekorea.com/', desc: '580개 병원이 선택한 마케팅 전문', cat: '마케팅' },
    { name: '덴탈비서', url: 'https://denb.co.kr/', desc: '프리미엄 치과 마케팅, 경영 자동화 플랫폼', cat: '마케팅' },
    { name: '부동산청년들 Medical', url: 'https://medicalteam.co.kr/', desc: '병의원 전문 부동산, 개원 입지 선정', cat: '부동산' },
];

function Interior() {
    const [tab, setTab] = useState('interior');
    const [searchTerm, setSearchTerm] = useState('');

    const sites = tab === 'interior' ? INTERIOR_SITES : CONSULTING_SITES;
    const filtered = sites.filter(s => {
        if (!searchTerm) return true;
        const q = searchTerm.toLowerCase();
        return s.name.toLowerCase().includes(q) || s.desc.toLowerCase().includes(q);
    });

    return (
        <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
            <h1 style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: 24, fontWeight: 700, margin: '0 0 20px' }}>
                <Palette size={28} color="#ec4899" /> 인테리어·개원
            </h1>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {[['interior', '인테리어'], ['consulting', '개원·컨설팅']].map(([k, v]) => (
                    <button key={k} onClick={() => { setTab(k); setSearchTerm(''); }}
                        style={{ padding: '10px 20px', border: '1px solid #e5e7eb', borderRadius: 10, background: tab === k ? '#fce7f3' : '#fff', color: tab === k ? '#be185d' : '#374151', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                        {v}
                    </button>
                ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', border: '1px solid #e5e7eb', borderRadius: 10, marginBottom: 20 }}>
                <Search size={16} color="#9ca3af" />
                <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="업체 검색" style={{ border: 'none', outline: 'none', flex: 1, fontSize: 14 }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {filtered.map(s => (
                    <a key={s.url} href={s.url} target="_blank" rel="noopener noreferrer"
                        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 16, background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, textDecoration: 'none', color: '#1f2937' }}>
                        <div>
                            <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4 }}>
                                <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>{s.name}</h3>
                                {s.cat && <span style={{ padding: '2px 8px', borderRadius: 4, background: '#fce7f3', color: '#be185d', fontSize: 10, fontWeight: 600 }}>{s.cat}</span>}
                            </div>
                            <p style={{ margin: 0, fontSize: 13, color: '#6b7280' }}>{s.desc}</p>
                        </div>
                        <ExternalLink size={18} color="#ec4899" style={{ flexShrink: 0 }} />
                    </a>
                ))}
            </div>
        </div>
    );
}

export default Interior;
